import React, { useRef } from "react";
import { S, STEPS, CATS } from "../styles/tokens";
import Spinner from "../components/Spinner";
import ScoreRing from "../components/ScoreRing";
import MiniBar from "../components/MiniBar";
import Chip from "../components/Chip";
import PremLoading from "../components/PremLoading";
import { useEnter } from "../lib/motion";

export default function AnalyzeView(props) {
  var user = props.user;
  var userPlan = props.userPlan;

  var introRef = useRef(null);
  var inputsRef = useRef(null);
  var resultsRef = useRef(null);
  useEnter(introRef, { y: 18, stagger: 0.08 });
  useEnter(inputsRef, { y: 22, stagger: 0.1, delay: 0.1 });
  useEnter(resultsRef, { y: 20, stagger: 0.07, deps: [props.result] });

  if (!user) {
    return (
      <div style={{ ...S.wrap, paddingTop: 100, paddingBottom: 80, textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
        <div style={{ fontFamily: "Georgia,serif", fontSize: 28, fontWeight: 500, marginBottom: 12 }}>Sign in to continue</div>
        <div style={{ fontSize: 14, color: "#7a6e64", marginBottom: 28 }}>You need an account to use SYNTRIX.</div>
        <button style={S.btnPrimary} onClick={props.onGoAuth}>
          Sign In / Sign Up →
        </button>
      </div>
    );
  }

  var jd = props.jd, setJd = props.setJd;
  var cv = props.cv, setCv = props.setCv;
  var dzState = props.dzState, dzMsg = props.dzMsg;
  var err = props.err;
  var loading = props.loading, loadStep = props.loadStep, prog = props.prog;
  var result = props.result, score = props.score;
  var rewrite = props.rewrite, cover = props.cover, linkedin = props.linkedin;
  var copied = props.copied;
  var hasAccess = props.hasAccess;

  return (
    <div style={{ ...S.wrap, paddingTop: 50, paddingBottom: 80 }}>
      <div ref={introRef} style={{ textAlign: "center", marginBottom: 38 }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 7, marginBottom: 16, fontSize: 10, letterSpacing: 2, color: "#5b8aaa", border: "1px solid rgba(91,138,170,.3)", padding: "5px 15px", borderRadius: 100, background: "rgba(91,138,170,.08)" }}>
          ✦ {userPlan.toUpperCase()} PLAN — {userPlan === "free" ? "FREE FEATURES" : "ALL FEATURES UNLOCKED"}
        </div>
        <h2 style={{ fontFamily: "Georgia,serif", fontSize: "clamp(24px,4vw,44px)", fontWeight: 500, letterSpacing: -.5, marginBottom: 10, color: "#2c2420" }}>
          Analyse Your Resume with <em style={{ color: "#a07828" }}>SYNTRIX AI</em>
        </h2>
        {userPlan === "free" && (
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(201,150,58,.08)", border: "1px solid rgba(201,150,58,.25)", borderRadius: 100, padding: "8px 18px", fontSize: 12, color: "#a07828", marginTop: 10 }}>
            ⭐ <span>Free plan: <strong>5 analyses/month</strong> — <button onClick={props.onGoLanding} style={{ background: "none", border: "none", color: "#a07828", fontFamily: "inherit", fontSize: 12, fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}>Upgrade for unlimited</button></span>
          </div>
        )}
      </div>

      {/* Inputs */}
      <div ref={inputsRef} className="inp-flex" style={{ display: "flex", gap: 18, marginBottom: 22, flexWrap: "wrap" }}>
        <div style={S.inpCard}>
          <div style={S.inpHead}>
            <div style={{ width: 28, height: 28, borderRadius: 8, background: "rgba(201,150,58,.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, flexShrink: 0 }}>📋</div>
            <div>
              <div style={{ fontFamily: "Georgia,serif", fontWeight: 600, fontSize: 14 }}>Job Description</div>
              <div style={{ fontSize: 9, color: "#7a6e64", letterSpacing: 1.5, marginTop: 1 }}>PASTE THE FULL JD HERE</div>
            </div>
          </div>
          <div style={S.inpBody}>
            <textarea style={S.ta} rows={11} value={jd} onChange={function(e) { setJd(e.target.value); }}
              placeholder={"Paste the complete job description here...\n\nInclude job title, responsibilities, required skills, qualifications."} />
          </div>
        </div>

        <div style={S.inpCard}>
          <div style={S.inpHead}>
            <div style={{ width: 28, height: 28, borderRadius: 8, background: "rgba(107,143,113,.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, flexShrink: 0 }}>📄</div>
            <div>
              <div style={{ fontFamily: "Georgia,serif", fontWeight: 600, fontSize: 14 }}>Your Resume</div>
              <div style={{ fontSize: 9, color: "#7a6e64", letterSpacing: 1.5, marginTop: 1 }}>PASTE TEXT OR UPLOAD FILE</div>
            </div>
          </div>
          <div style={S.inpBody}>
            <textarea style={S.ta} rows={7} value={cv} onChange={function(e) { setCv(e.target.value); }}
              placeholder={"Paste your complete resume here...\n\nInclude professional summary, work experience, education, skills."} />
            <div
              style={{ ...S.dz, ...(dzState === "over" ? S.dzOver : {}), borderColor: dzState === "ok" ? "#6b8f71" : dzState === "err" ? "#b85c38" : "#d4c4ac" }}
              onClick={props.onDzClick}
              onDragOver={props.onDragOver}
              onDragLeave={props.onDragLeave}
              onDrop={props.onDrop}
            >
              <input ref={props.fileRef} type="file" accept=".txt,.pdf,.doc,.docx" style={{ display: "none" }}
                onChange={props.onFileChange} />
              <div style={{ fontSize: 22, marginBottom: 6 }}>{dzState === "ok" ? "✅" : dzState === "err" ? "⚠️" : dzState === "loading" ? "⏳" : "📎"}</div>
              {dzState === "idle" && (
                <div>
                  <div style={{ fontSize: 12, color: "#4a3f38" }}><strong>Click to upload</strong> or drag &amp; drop</div>
                  <div style={{ fontSize: 10, color: "#7a6e64", marginTop: 4 }}>PDF · DOCX · TXT — all supported</div>
                </div>
              )}
              {dzState !== "idle" && <div style={{ fontSize: 11, color: dzState === "ok" ? "#6b8f71" : dzState === "err" ? "#b85c38" : "#7a6e64", marginTop: 4 }}>{dzMsg}</div>}
            </div>
          </div>
        </div>
      </div>

      {err && <div style={S.errBar}>⚠ {err}</div>}

      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <button style={{ ...S.btnPrimary, ...(loading ? { opacity: .45, cursor: "not-allowed" } : {}) }} onClick={props.runAnalysis} disabled={loading}>
          <svg width={14} height={14} viewBox="0 0 14 14" fill="none"><path d="M7 1L8.8 5H13L9.6 7.5L11 12L7 9.5L3 12L4.4 7.5L1 5H5.2L7 1Z" fill="currentColor" /></svg>
          Analyze with SYNTRIX
        </button>
      </div>

      {loading && (
        <div style={S.loadPanel}>
          <Spinner />
          <div style={{ fontFamily: "Georgia,serif", fontSize: 17, fontWeight: 500, color: "#2c2420", margin: "14px 0 5px" }}>{STEPS[loadStep] ? STEPS[loadStep][0] : "Processing…"}</div>
          <div style={{ fontSize: 10, color: "#7a6e64", letterSpacing: 2 }}>STEP {loadStep + 1} OF {STEPS.length}</div>
          <div style={{ background: "#e4d9c8", borderRadius: 100, height: 3, margin: "18px auto 0", maxWidth: 260, overflow: "hidden" }}>
            <div style={{ height: "100%", borderRadius: 100, width: prog + "%", background: "linear-gradient(90deg,#a07828,#e8c06a)", transition: "width .5s ease" }} />
          </div>
        </div>
      )}

      {result && (
        <div ref={resultsRef}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, flexWrap: "wrap", gap: 10 }}>
            <div style={{ fontFamily: "Georgia,serif", fontSize: 22, fontWeight: 500 }}>ATS Analysis Report</div>
            <div style={{ fontSize: 10, color: "#7a6e64", letterSpacing: 1.5 }}>Analysed {new Date().toLocaleDateString("en-GB")} at {new Date().toLocaleTimeString()}</div>
          </div>

          <div className="score-sec" style={S.scoreSec}>
            <ScoreRing score={score} />
            <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
              <div style={{ fontFamily: "Georgia,serif", fontSize: 26, fontWeight: 500, lineHeight: 1.15 }}>{result.verdict}</div>
              <div style={{ fontSize: 13, color: "#6b5e56", lineHeight: 1.78, maxWidth: 440 }}>{result.summary}</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
                {(result.chips || []).map(function(c, i) { return <Chip key={i} label={c.label} type={c.type} />; })}
              </div>
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(185px,1fr))", gap: 13, marginBottom: 16 }}>
            {CATS.map(function(cat) {
              var item = (result.breakdown && result.breakdown[cat.key]) || { score: 0, max: 25, note: "" };
              return (
                <div key={cat.key} style={{ background: "#fefcfa", border: "1px solid rgba(180,160,140,.28)", borderRadius: 16, padding: 18 }}>
                  <div style={{ fontSize: 9, letterSpacing: 2, color: "#7a6e64", marginBottom: 8 }}>{cat.label.toUpperCase()}</div>
                  <div style={{ display: "flex", alignItems: "baseline", gap: 3, marginBottom: 8 }}>
                    <span style={{ fontFamily: "Georgia,serif", fontSize: 32, fontWeight: 500, color: cat.color }}>{item.score || 0}</span>
                    <span style={{ fontSize: 11, color: "#7a6e64" }}>/ {item.max || 25}</span>
                  </div>
                  <MiniBar pct={Math.round(((item.score || 0) / (item.max || 25)) * 100)} color={cat.color} />
                  <div style={{ fontSize: 10, color: "#6b5e56", marginTop: 7, lineHeight: 1.5 }}>{item.note}</div>
                </div>
              );
            })}
          </div>

          <div className="kw-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
            <div style={{ background: "#fefcfa", border: "1px solid rgba(180,160,140,.28)", borderRadius: 16, overflow: "hidden" }}>
              <div style={{ padding: "12px 16px", borderBottom: "1px solid rgba(180,160,140,.16)", display: "flex", alignItems: "center", gap: 7 }}>
                <span>🔑</span><span style={{ fontFamily: "Georgia,serif", fontWeight: 600, fontSize: 14 }}>Keyword Analysis</span>
              </div>
              <div style={{ padding: 16 }}>
                <div style={{ fontSize: 9, letterSpacing: 2, color: "#7a6e64", marginBottom: 8 }}>MATCHED</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                  {(result.matched_keywords || []).map(function(k) { return <span key={k} style={{ fontSize: 10, padding: "3px 10px", borderRadius: 6, border: "1px solid rgba(107,143,113,.25)", color: "#6b8f71", background: "rgba(107,143,113,.07)" }}>{k}</span>; })}
                </div>
                <div style={{ fontSize: 9, letterSpacing: 2, color: "#7a6e64", margin: "14px 0 8px" }}>MISSING</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                  {(result.missing_keywords || []).map(function(k) { return <span key={k} style={{ fontSize: 10, padding: "3px 10px", borderRadius: 6, border: "1px solid rgba(184,92,56,.25)", color: "#b85c38", background: "rgba(184,92,56,.07)" }}>{k}</span>; })}
                </div>
              </div>
            </div>
            <div style={{ background: "#fefcfa", border: "1px solid rgba(180,160,140,.28)", borderRadius: 16, overflow: "hidden" }}>
              <div style={{ padding: "12px 16px", borderBottom: "1px solid rgba(180,160,140,.16)", display: "flex", alignItems: "center", gap: 7 }}>
                <span>💡</span><span style={{ fontFamily: "Georgia,serif", fontWeight: 600, fontSize: 14 }}>Improvement Suggestions</span>
              </div>
              <div style={{ padding: 16 }}>
                <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 9 }}>
                  {(result.suggestions || []).map(function(s, i) {
                    return (
                      <li key={i} style={{ display: "flex", gap: 8, fontSize: 12, lineHeight: 1.65, color: "#4a3f38" }}>
                        <span style={{ color: "#a07828", flexShrink: 0 }}>→</span><span>{s}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>

          <div style={{ background: "#fefcfa", border: "1px solid rgba(180,160,140,.28)", borderRadius: 16, overflow: "hidden", marginBottom: 16 }}>
            <div style={{ padding: "12px 16px", borderBottom: "1px solid rgba(180,160,140,.16)", display: "flex", alignItems: "center", gap: 7 }}>
              <span>🧠</span><span style={{ fontFamily: "Georgia,serif", fontWeight: 600, fontSize: 14 }}>Detailed Analysis</span>
            </div>
            <div style={{ padding: 22, fontSize: 12.5, lineHeight: 1.95, color: "#4a3f38" }}
              dangerouslySetInnerHTML={{ __html: (result.detailed_analysis || "").replace(/###\s*(.+)/g, "<strong style='font-family:Georgia,serif;font-size:15px;display:block;margin:18px 0 7px;color:#2c2420'>$1</strong>") }} />
          </div>

          {/* AI Resume Rewrite */}
          <div style={{ marginBottom: 14 }}>
            <div className="prem-hdr" style={S.premHdrPro}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 16 }}>✍️</span>
                <div>
                  <div style={{ fontFamily: "Georgia,serif", fontSize: 17, fontWeight: 600 }}>AI Resume Rewrite</div>
                  <div style={{ fontSize: 11, color: "#7a6e64", marginTop: 1 }}>Full resume rewritten and optimised for this exact job</div>
                </div>
              </div>
              <span style={S.ubPro}>{hasAccess("rewrite") ? "✓ PRO UNLOCKED" : "🔒 PRO REQUIRED"}</span>
            </div>
            <div style={S.premContent}>
              {!hasAccess("rewrite") ? (
                <div style={{ textAlign: "center", padding: "28px 0" }}>
                  <div style={{ fontSize: 32, marginBottom: 12 }}>🔒</div>
                  <div style={{ fontFamily: "Georgia,serif", fontSize: 18, fontWeight: 500, marginBottom: 8 }}>Unlock AI Resume Rewrite</div>
                  <div style={{ fontSize: 12, color: "#7a6e64", marginBottom: 20, lineHeight: 1.6 }}>Get a fully rewritten ATS-optimised resume tailored to this exact job description.</div>
                  <button onClick={props.onGoLanding} style={{ background: "#a07828", color: "#fefcfa", border: "none", borderRadius: 100, padding: "11px 28px", fontFamily: "inherit", fontWeight: 700, fontSize: 12, letterSpacing: 1.5, cursor: "pointer" }}>
                    Upgrade to Pro — $9/mo
                  </button>
                </div>
              ) : !rewrite ? <PremLoading msg="Generating your optimised resume…" /> : rewrite.startsWith("ERROR") ? (
                <div style={{ color: "#b85c38", fontSize: 12 }}>⚠ {rewrite}</div>
              ) : (
                <div>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(107,143,113,.1)", border: "1px solid rgba(107,143,113,.25)", borderRadius: 100, padding: "6px 14px", fontSize: 12, color: "#6b8f71", marginBottom: 14 }}>
                    ✦ Estimated ATS score improvement: +10 to +20 points
                  </div>
                  <div style={{ fontSize: 12.5, lineHeight: 2, color: "#4a3f38", whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{ __html: rewrite.replace(/###\s*(.+)/g, "<strong style='font-family:Georgia,serif;font-size:15px;display:block;margin:16px 0 6px;color:#2c2420'>$1</strong>") }} />
                  <button style={S.copyBtn} onClick={function() { props.copyText(rewrite, "rw"); }}>{copied.rw ? "✓ Copied!" : "📋 Copy Rewritten Resume"}</button>
                </div>
              )}
            </div>
          </div>

          {/* AI Cover Letter */}
          <div style={{ marginBottom: 14 }}>
            <div className="prem-hdr" style={S.premHdrElite}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 16 }}>📝</span>
                <div>
                  <div style={{ fontFamily: "Georgia,serif", fontSize: 17, fontWeight: 600 }}>AI Cover Letter</div>
                  <div style={{ fontSize: 11, color: "#7a6e64", marginTop: 1 }}>Personalised cover letter tailored to this role</div>
                </div>
              </div>
              <span style={S.ubElite}>{hasAccess("cover_letter") ? "✓ ELITE UNLOCKED" : "🔒 ELITE REQUIRED"}</span>
            </div>
            <div style={S.premContent}>
              {!hasAccess("cover_letter") ? (
                <div style={{ textAlign: "center", padding: "28px 0" }}>
                  <div style={{ fontSize: 32, marginBottom: 12 }}>🔒</div>
                  <div style={{ fontFamily: "Georgia,serif", fontSize: 18, fontWeight: 500, marginBottom: 8 }}>Unlock AI Cover Letter</div>
                  <div style={{ fontSize: 12, color: "#7a6e64", marginBottom: 20, lineHeight: 1.6 }}>A tailored professional cover letter written specifically for this job and your experience.</div>
                  <button onClick={props.onGoLanding} style={{ background: "#5b8aaa", color: "#fefcfa", border: "none", borderRadius: 100, padding: "11px 28px", fontFamily: "inherit", fontWeight: 700, fontSize: 12, letterSpacing: 1.5, cursor: "pointer" }}>
                    Upgrade to Elite — $24/mo
                  </button>
                </div>
              ) : !cover ? <PremLoading msg="Writing your cover letter…" /> : cover.startsWith("ERROR") ? (
                <div style={{ color: "#b85c38", fontSize: 12 }}>⚠ {cover}</div>
              ) : (
                <div>
                  <div style={{ fontSize: 12.5, lineHeight: 2, color: "#4a3f38", whiteSpace: "pre-wrap" }}>{cover}</div>
                  <button style={S.copyBtn} onClick={function() { props.copyText(cover, "cl"); }}>{copied.cl ? "✓ Copied!" : "📋 Copy Cover Letter"}</button>
                </div>
              )}
            </div>
          </div>

          {/* LinkedIn */}
          <div style={{ marginBottom: 20 }}>
            <div className="prem-hdr" style={S.premHdrElite}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 16 }}>💼</span>
                <div>
                  <div style={{ fontFamily: "Georgia,serif", fontSize: 17, fontWeight: 600 }}>LinkedIn Optimisation</div>
                  <div style={{ fontSize: 11, color: "#7a6e64", marginTop: 1 }}>Headline, About &amp; Skills rewritten for this role type</div>
                </div>
              </div>
              <span style={S.ubElite}>{hasAccess("linkedin") ? "✓ ELITE UNLOCKED" : "🔒 ELITE REQUIRED"}</span>
            </div>
            <div style={S.premContent}>
              {!hasAccess("linkedin") ? (
                <div style={{ textAlign: "center", padding: "28px 0" }}>
                  <div style={{ fontSize: 32, marginBottom: 12 }}>🔒</div>
                  <div style={{ fontFamily: "Georgia,serif", fontSize: 18, fontWeight: 500, marginBottom: 8 }}>Unlock LinkedIn Optimisation</div>
                  <div style={{ fontSize: 12, color: "#7a6e64", marginBottom: 20, lineHeight: 1.6 }}>AI-rewritten LinkedIn headline, about section, and skills list to attract recruiters.</div>
                  <button onClick={props.onGoLanding} style={{ background: "#5b8aaa", color: "#fefcfa", border: "none", borderRadius: 100, padding: "11px 28px", fontFamily: "inherit", fontWeight: 700, fontSize: 12, letterSpacing: 1.5, cursor: "pointer" }}>
                    Upgrade to Elite — $24/mo
                  </button>
                </div>
              ) : !linkedin ? <PremLoading msg="Optimising your LinkedIn profile…" /> : linkedin.startsWith("ERROR") ? (
                <div style={{ color: "#b85c38", fontSize: 12 }}>⚠ {linkedin}</div>
              ) : (
                <div>
                  <div style={{ fontSize: 12.5, lineHeight: 2, color: "#4a3f38" }}
                    dangerouslySetInnerHTML={{ __html: linkedin.replace(/###\s*(.+)/g, "<strong style='font-family:Georgia,serif;font-size:15px;display:block;margin:16px 0 6px;color:#2c2420'>$1</strong>") }} />
                  <button style={S.copyBtn} onClick={function() { props.copyText(linkedin, "li"); }}>{copied.li ? "✓ Copied!" : "📋 Copy LinkedIn Content"}</button>
                </div>
              )}
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            <button style={S.btnReset} onClick={props.doReset}>↺ Analyse Another Resume</button>
          </div>
        </div>
      )}
    </div>
  );
}
